import { z } from 'zod'
import { Id } from './common-schemas'
import { GarItem } from './gar-item'

export namespace NormDocKind {
  export interface Data {
    /** @description Identifier of the type of normative document */
    readonly id: number

    /** @description Name */
    readonly name: string
  }
}

/** @description Information on the type of normative document */
export class NormDocKind extends GarItem<'NormDocKind', NormDocKind.Data> {
  static readonly SCHEMA: GarItem.Schema<NormDocKind.Data> = z
    .strictObject({
      ID: Id,

      NAME: z.string().describe('Name'),
    })
    .transform<NormDocKind.Data>(attributes => ({
      id: attributes.ID,
      name: attributes.NAME,
    }))

  readonly type = 'NormDocKind'

  protected get schema() {
    return NormDocKind.SCHEMA
  }
}
